import React from 'react'
import OrderStore from '../../stores/order-store'
import ImageStore from "../../stores/image-store"
import UploadStore from '../../stores/upload-store'
import GalleryItem from './selector-gallery-item'
import Config from '../../config'
import Paginator from '../utils/paginator'
import LargePreviewImage from './selector-gallery-largepreviewimage'
import Modal from '../utils/ope-modal'
import TouchButton from '../utils/ope-touch-button'
import createReactClass from 'create-react-class'


var SelectorGallery = createReactClass({
    mounted: false,

	getInitialState: function() {
		return {page: 1, perPage: Config.GalleryImagesPerPage, largeImagePreview: null};
	},

	getPaginationStartIndex: function () {
		return (this.state.page-1) * this.state.perPage;
	},
	isImageOnCurrentPage: function (index) {
		var startIndex = this.getPaginationStartIndex();
		if (index >= startIndex && index < startIndex+this.state.perPage) {
			return true;
		}
		return false;
	},
    /**
     * @param {{orderItems: Array, images: Object}} nextProps
     */
	componentWillReceiveProps: function (nextProps) {

		//This will switch page if the customer has removed all images on last pagination page
		//so that the customer will not be on an empty page anymore
		var pageCount = Math.ceil(Object.keys(nextProps.images).length/this.state.perPage);
		if (pageCount < this.state.page) {
			if (pageCount === 0) {
				pageCount = 1;
			}
			if (this.mounted) {
				this.setState({page: pageCount});
			}
		}
	},
	updatePage: function (page) {
		if (this.mounted) {
			this.setState({page: page});
		}
	},
	viewLargeImage: function (imageId, orderItem) {
		if (this.mounted) {
			this.setState({largeImagePreview: imageId, largeImagePreviewOrderItem: orderItem});
		}
	},
	_closePreviewImage: function () {
		if (this.mounted) {
			this.setState({largeImagePreview: null});
		}
	},
	render: function() {
		var self = this;
		var itemCount = 0;
		var imageDuplicateList = [];
		var uploadedItems = [];
		var i = 0;
		for (var key in this.props.images) {
			if (this.props.images.hasOwnProperty(key)) {
				var imageItem = this.props.images[key];
				var orderItem = OrderStore.getFirstItemByImageId(imageItem.getId());
				if (orderItem) {
					itemCount++;
					if (self.isImageOnCurrentPage(i)) {
						//todo Do we need it?
						imageItem.setVisible(true);
						imageDuplicateList.push(imageItem.getId());
						uploadedItems.push (
			      			<GalleryItem imageItem={imageItem} orderItem={orderItem} key={imageItem.getId()} viewLargeCallback={self.viewLargeImage} />
			      		);
					} else {
                        //todo Do we need it?
						imageItem.setVisible(false);
					}
				}
			}
			i++;
		}

		var largeImagePreview = null;

		if (this.state.largeImagePreview !== null) {
			largeImagePreview =
			<Modal closeCallback={this._closePreviewImage} id="large-preview" show={true}>
				<div style={{padding: "20px"}}>
					<LargePreviewImage imageId={this.state.largeImagePreview} orderItem={this.state.largeImagePreviewOrderItem} />
				</div>
			</Modal>;
		}

		if( this.state.showGallery ) {
			const lastPage = Math.floor(itemCount / this.state.perPage) + 1
			return (
				<section className="ope-gallery">
					{largeImagePreview}
					<header className="ope-gallery__header">
						<h3>{_("Your photo collection")}</h3>
					</header>

					<ul className="row">
						{uploadedItems}
						{ this.state.isUploading && (this.state.page == lastPage) && <GalleryItem key={-1}  /> }
					</ul>
					<Paginator perPage={this.state.perPage} itemCount={itemCount} page={this.state.page} pageClickCallback={this.updatePage}/>
					<br/><br/>
				</section>
			)
		}
		else {
			return <span />
		}
	},
	componentDidMount: function() {
			this.mounted = true;
			UploadStore.addChangeListener(this._onUploadChange);
			OrderStore.addChangeListener(this._onUploadChange);
	},
	componentWillUnmount: function() {
			this.mounted = false;
			UploadStore.removeChangeListener(this._onUploadChange);
			OrderStore.removeChangeListener(this._onUploadChange);
	},
	_onUploadChange: function() {
		const orders = OrderStore.getItems();
		const data = UploadStore.getData();
		const isUploading = data.totalImagesToUpload > data.serverData;
		const showGallery = orders.length > 0 || data.uploadStarted;
		this.setState({isUploading: isUploading, showGallery: showGallery});
	}
});

export default SelectorGallery;
